export enum ImagePosition {
    Left = 'left',
    Right = 'right',
    Top = 'top',
}
